import * as Yup from 'yup';
import { useEffect, useState } from "react";
import { FormikProvider, getIn, useFormik } from "formik";
import ZapSignActivate from "../../UploadInfoApis/ZapSignActivate";
import { createContract } from "../../../../../services/integration.api";
import ZapSignConfirmation from "../../UploadInfoApis/ZapSignConfirmation";
import { IRenter, SignatureInfo } from "../../../../../../../types/renter.type";
import { changePlanRenter } from "../../../../../../../common/services/renters.api";
import ComboBoxFormik from "../../../../../../../common/components/form/ComboBoxFormik";
import ButtonWithLoader from "../../../../../../../common/components/ui/loading/ButtonLoading";
import { useToastContext } from "../../../../../../../common/components/ui/toast/toast.context";
import { AvailableAdditionsFieldFormik } from "../../../../forms/fields/AvailableAdditionsFieldFormik";
import { DateSubscriptionFormik } from "../../../../forms/fields/DateSubscriptionFormik";
import { AvailablePeriods } from "../../../../forms/fields/AvailablePeriods";
import { getPlanByLabel } from "../../../../../../../types/plan.type";
import TextAreaFormik from '../../../../../../../common/components/form/TextAreaFormik';
import { ImageBondVehicleRenterRow } from './field/ImageBondVehicleRenterRow';
import { saveVehicleRecords } from '../../../../../../../common/services/vehicles.api';
import { AvailableVehiclesFieldFormik } from '../../../../forms/fields/AvailableVehiclesFieldFormik';

const validationSchema = Yup.object().shape({
  reason: Yup.string().required('Motivo da troca é obrigatório'),
  returnReason: Yup.string().required("Descrição da cobrança é obrigatória"),
})

export default function ChangePlanModal(renter: IRenter) {
  const { notifySuccess, notifyError } = useToastContext()
  const [bindChangePlan, setBindChangePlan] = useState(false)
  const [signatureInfo, setSignatureInfo] = useState<SignatureInfo>()
  const [complement, setComplement] = useState('');
  const [plan, setPlan] = useState("");
  const vehicleHistory = renter?.desactivationData?.vehicleHistory || [];
  const actualVehicle = renter?.activationData?.vehicle;
  const vehicleId = actualVehicle?.id || ''; // Valor default vazio

  const partnerId = actualVehicle?.partnerId ||
    (vehicleHistory.length > 0 ? vehicleHistory[vehicleHistory.length - 1].partnerId : undefined);

  const handlePeriodChange = (selectedPeriod: string) => {
    setPlan(selectedPeriod)
    formik.setFieldValue('period', getPlanByLabel(selectedPeriod))
  };

  const initialRegisters = [
    { type: 'Frente do veículo', content: '' },
    { type: 'Lateral direita do veículo', content: '' },
    { type: 'Lateral esquerda do veículo', content: '' },
    { type: 'Traseira do veículo', content: '' },
    { type: 'Odômetro', content: '' },
  ];


  function handleSignature(contractInfo) {
    setSignatureInfo(contractInfo)
  }

  const initialValues = {
    renterId: renter._id!,
    vehicleId,
    reason: "",
    returnReason: "",
    period: { value: "", label: "", months: 0 },
    additions: [],
    subscriptionInitialDate: new Date(),
    registers: initialRegisters
  }


  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async (values) => {
      try {
        if (!values.renterId) {
          notifyError('ID do locatário não encontrado');
          return;
        } setBindChangePlan(true);

        const result = await changePlanRenter(values);

        if (result) {
          notifySuccess('Plano trocado com sucesso');
        }

        // Verificar se há registros válidos para enviar
        const hasValidRegisters = values.registers &&
          values.registers.some(reg => reg.type && reg.content);

        if (hasValidRegisters) {
          const savePhotoDelivery = {
            renterId,
            vehicleId: values.vehicleId,
            photos: values.registers,
            nameRenter: renter.name,
            licensePlate: vehicle?.licensePlate,
            switchDescription: complement,
            switchReason: reason,
          };

          const resultPhoto = await saveVehicleRecords(savePhotoDelivery);

          if (!resultPhoto.ok) {
            notifyError(resultPhoto.message as string);
            return;
          }

          notifySuccess("Fotos salvas com sucesso");
        }
      } catch (error) {
        notifyError((error as string) || "Erro ao trocar plano");
      } finally {
        setBindChangePlan(false);
      }
    },
  })


  const period = getIn(formik.values, 'period')
  const renterId = getIn(formik.values, 'renterId')
  const additions = getIn(formik.values, 'additions')
  const vehicle = getIn(formik.values, 'vehicle');
  const reason = getIn(formik.values, 'returnReason');

  useEffect(() => {
    if (vehicle && vehicle._id) {
      if (vehicle._id !== formik.values.vehicleId) {
        formik.setFieldValue('vehicleId', vehicle._id);
      }
    } else if (actualVehicle?.id) {
      formik.setFieldValue('vehicleId', actualVehicle.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehicle, actualVehicle?.id]);

  // Limpar e redefinir os registros quando o modal é montado
  useEffect(() => {
    formik.setFieldValue('registers', initialRegisters);
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const contractData = {
    renterId: renterId,
    vehicleId: formik.values.vehicleId,
    period: period,
    additions: additions,
  }


  return (
    <div>
      <FormikProvider value={formik}>
        <section className="grid grid-cols-2 gap-2">
          <ComboBoxFormik
            name="reason"
            label="Motivo da troca"
            options={[
              { value: "", label: "-" },
              { value: "NovaMoto", label: "Experiência Insatisfatória com a Moto Atual" },
              { value: "MudanSeguro", label: "Mudança nas Condições de Seguro " },
              { value: "AtualizaçãoContrato:", label: "Ofertas ou Promoções Especiais" },
              { value: "UpgradeVeículo:", label: "Upgrade de Veículo" },
              { value: "Econômico", label: "Econômico" },
              { value: "Acidente", label: "Acidente" },
              { value: "Outro", label: "Outro" },
            ]}
            required={true} />

          <DateSubscriptionFormik className="" />
          <AvailablePeriods onChange={handlePeriodChange} action="changePlan" />
          <AvailableAdditionsFieldFormik />
        </section>
        <div>
          {!renter.activationData.vehicle.id && plan && partnerId && (
            <>
              <AvailableVehiclesFieldFormik
                partnerId={partnerId}
                companyId={renter.companyId}
                required={true} /><div className="grid gap-2">
                <h2 className="text-2xl font-semibold">Registros do veículo</h2>
                {(!formik.values.vehicleId || formik.values.vehicleId === '') && (
                  <small className="text-redPrimary">Selecione um veículo para adicionar as fotos</small>
                )}

                {formik.values.registers?.map((doc, index) => (
                  <div
                    key={index}
                    className={`space-x-3 px-3 py-2 my-0 rounded ${index % 2 ? 'bg-gray/5' : 'bg-gray/25'}`}
                  >
                    <ImageBondVehicleRenterRow
                      initialData={doc || {}}
                      name={`registers.${index}`}
                      onRemoveClick={() => {
                        const updatedRegisters = [...formik.values.registers];
                        updatedRegisters.splice(index, 1);
                        formik.setFieldValue('registers', updatedRegisters);
                      }}
                      prefix="entrega"
                    />
                  </div>
                ))}

                <button
                  type="button"
                  className="disabled:text-black/50"
                  onClick={() => {
                    // Adiciona ao mesmo campo que está mapeando
                    const registers = [...(formik.values.registers || [])];
                    registers.push({ type: '', content: '' });
                    formik.setFieldValue('registers', registers);
                  }}
                >
                  + registro
                </button>
              </div></>
          )}
        </div>
        <div className="flex flex-col gap-6"> {/* Adicione gap para espaçamento */}
          <div className="flex-1"> {/* Garante que o TextArea ocupe espaço disponível */}
            <TextAreaFormik
              label="Complemento sobre o motivo da troca:"
              name="returnReason"
              value={complement}
              onChange={(e) => setComplement(e.target.value)}
              required={true}
            />
          </div>

          <div className="flex justify-end mt-6"> {/* Ajuste no margin-top */}
            <ButtonWithLoader
              type="button"
              disabled={!formik.isValid}
              isLoading={bindChangePlan}
              onClick={formik.handleSubmit}
            >
              Trocar Plano
            </ButtonWithLoader>
          </div>
        </div>
      </FormikProvider>
      <div className="mt-4">
        <ZapSignActivate
          onSave={function (): void {
            throw new Error('Function not implemented.');
          }} contractData={contractData}
          handleSignature={handleSignature}
          contractFn={createContract} />
        {signatureInfo?.ok && (
          <ZapSignConfirmation
            contractInfo={signatureInfo} />)}
      </div>
    </div>
  )
}